/*
  Configurateur Harmony — prévisualisation des packs sur mesure.
  Pas de panier : le client compose sa config, voit un prix indicatif,
  puis réserve un échange (cal.com) avec le récap pré-rempli dans « Notes ».

  Règles des modules :
  - 1 Bridge toujours.
  - 1 Link Power par enceinte amplifiée (avants seulement si fournies par Octavio).
  - Arrières actives du client : 1 Link Core Optique à la place des 2 Link Power.
  - Caisson (le nôtre ou celui du client) : 1 Link Core.
  - Option 100W par emplacement, jamais pour les enceintes de la sélection Octavio.
*/
(function () {
	function init(root) {
		var cfgEl = root.querySelector('[data-hc-config]');
		var CFG = {};
		try { CFG = JSON.parse(cfgEl.textContent); } catch (e) {}
		var P = CFG.prices || {};
		var IMG = CFG.images || {};
		var CAL = CFG.calUrl || 'https://cal.octavio.pro/team/octavio/projet-harmony';

		var ZONES = [
			{ id: 'front', label: 'Avant', title: 'Enceintes avant', sub: 'Les deux enceintes de part et d’autre de l’écran.' },
			{ id: 'rear', label: 'Arrière', title: 'Enceintes arrière', sub: 'Derrière vous : elles créent l’enveloppement.' },
			{ id: 'center', label: 'Centrale', title: 'Enceinte centrale', sub: 'Pour des dialogues détachés, au centre de l’image.' },
			{ id: 'sub', label: 'Caisson', title: 'Caisson de basses', sub: 'Des graves physiques, pour le cinéma comme la musique.' },
			{ id: 'ceil', label: 'Plafond', title: 'Enceintes plafond', sub: 'La dimension verticale : les effets passent au-dessus de vous.' }
		];
		var GROUPS = {
			front: { ours: ['r3', 'devis'], own: ['own'], none: false },
			rear: { ours: ['minx', 'r1', 'r3', 'devis'], own: ['own', 'ownActive'], none: true },
			center: { ours: ['minx', 'devis'], own: ['own'], none: true },
			sub: { ours: ['msx'], own: ['own'], none: true },
			ceil: { ours: ['devis'], own: ['own'], none: true }
		};
		var SEG = {
			front: ['Sélection Octavio', 'J’ai déjà les miennes'],
			rear: ['Sélection Octavio', 'J’ai déjà les miennes', 'Sans'],
			center: ['Sélection Octavio', 'J’ai déjà la mienne', 'Sans'],
			sub: ['Sélection Octavio', 'J’ai déjà le mien', 'Sans'],
			ceil: ['Sélection Octavio', 'J’ai déjà les miennes', 'Sans']
		};
		var NOTE_OWN = {
			front: 'Vos enceintes avant restent branchées sur votre ampli stéréo.',
			center: 'Votre centrale est amplifiée par un Link Power.',
			sub: 'Votre caisson est piloté par un Link Core.',
			ceil: 'Vos enceintes plafond sont amplifiées par deux Link Power.'
		};
		var OCTAVIO_MODELS = ['minx', 'r1', 'r3'];

		function info(z, id) {
			var M = {
				r3: { name: 'Monitor Audio Radius 3 4G', desc: 'Compacte haut de gamme · la paire', img: IMG.r3 },
				r1: { name: 'Monitor Audio Radius 1 4G', desc: 'Compacte · la paire', img: IMG.r1 },
				minx: { name: 'Cambridge Minx 22', desc: z === 'center' ? 'Avec son support' : 'Ultra-compacte · la paire', img: IMG.minx },
				msx: { name: 'Cambridge MSX SUB 300', desc: 'Compact et précis', img: IMG.msx },
				devis: { name: z === 'ceil' ? 'Modèle conseillé par nos experts' : 'Un autre modèle', desc: 'Nous vous faisons une proposition' },
				own: { name: z === 'rear' ? 'Enceintes passives' : 'Mes enceintes', desc: z === 'rear' ? 'Amplifiées par deux Link Power' : '' },
				ownActive: { name: 'Enceintes actives', desc: 'Reliées par un Link Core Optique' }
			};
			return M[id];
		}
		function groupOf(z, id) {
			return GROUPS[z].ours.indexOf(id) > -1 ? 'ours' : (GROUPS[z].own.indexOf(id) > -1 ? 'own' : 'none');
		}
		function eur(n) { return n.toLocaleString('fr-FR') + ' €'; }
		function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

		var state = {
			zone: 'front',
			sel: { front: 'own', rear: 'none', center: 'none', sub: 'none', ceil: 'none' },
			touched: false,
			stand: { front: false, rear: false },
			w100: { front: false, rear: false, center: false, ceil: false },
			recap: false
		};

		function zoneLines(z, o) {
			var L = [];
			var lp = function (n) {
				var big = state.w100[z] && OCTAVIO_MODELS.indexOf(o) < 0;
				L.push({ k: n + ' × Link Power ' + (big ? '100W' : '40W'), v: n * (big ? P.lp100 : P.lp40), mod: true, n: n });
			};
			var stand = function () { if (state.stand[z]) L.push({ k: 'Pieds Stand Floor (paire)', v: P.stand }); };
			if (z === 'front') {
				if (o === 'r3') { L.push({ k: 'Radius 3 4G avant (paire)', v: P.r3 }); stand(); lp(2); }
				if (o === 'devis') { L.push({ k: 'Enceintes avant', devis: true }); lp(2); }
			} else if (z === 'rear') {
				if (o === 'own') lp(2);
				if (o === 'ownActive') L.push({ k: 'Link Core Optique', v: P.coreOpt, mod: true });
				if (o === 'minx') { L.push({ k: '2 × Cambridge Minx 22', v: 2 * P.minx }); lp(2); }
				if (o === 'r1') { L.push({ k: 'Radius 1 4G arrière (paire)', v: P.r1 }); stand(); lp(2); }
				if (o === 'r3') { L.push({ k: 'Radius 3 4G arrière (paire)', v: P.r3 }); stand(); lp(2); }
				if (o === 'devis') { L.push({ k: 'Enceintes arrière', devis: true }); lp(2); }
			} else if (z === 'center') {
				if (o === 'own') lp(1);
				if (o === 'minx') { L.push({ k: 'Cambridge Minx 22 + support', v: P.minx + P.minxSupport }); lp(1); }
				if (o === 'devis') { L.push({ k: 'Enceinte centrale', devis: true }); lp(1); }
			} else if (z === 'sub') {
				if (o === 'own') L.push({ k: 'Link Core', v: P.core, mod: true });
				if (o === 'msx') { L.push({ k: 'Cambridge MSX SUB 300', v: P.msx }); L.push({ k: 'Link Core', v: P.core, mod: true }); }
			} else if (z === 'ceil') {
				if (o === 'own') lp(2);
				if (o === 'devis') { L.push({ k: 'Enceintes plafond', devis: true }); lp(2); }
			}
			return L;
		}

		function compute() {
			var lines = [{ k: 'Harmony Bridge', v: P.bridge, mod: true }];
			ZONES.forEach(function (z) { lines = lines.concat(zoneLines(z.id, state.sel[z.id])); });
			// Modules équivalents à un pack (1 Bridge + N Link Power, avec ou sans Link Core) :
			// on applique le prix du pack. Un Link Power 100W occupe la place d'un 40W et un
			// Link Core Optique celle de deux 40W : seule la différence de prix s'ajoute.
			var cnt = { lp40: 0, other: 0, core: 0 };
			lines.forEach(function (l) {
				if (!l.mod || l.k === 'Harmony Bridge') return;
				var m = l.k.match(/^(\d+) × Link Power (40|100)W$/);
				if (m) cnt.lp40 += +m[1];
				else if (l.k === 'Link Core Optique') cnt.lp40 += 2;
				else if (l.k === 'Link Core') cnt.core += 1;
				else cnt.other += 1;
			});
			var PACKS = [
				{ name: 'Starter 4.0', lp40: 2, core: 0, price: P.packStarter },
				{ name: 'Cinéma 5.1', lp40: 3, core: 1, price: P.packCinema },
				{ name: 'Référence 5.1.2', lp40: 5, core: 1, price: P.packReference }
			];
			PACKS.forEach(function (pk) {
				if (!pk.price || cnt.other || cnt.lp40 !== pk.lp40 || cnt.core !== pk.core) return;
				var diff = pk.price - (P.bridge + pk.lp40 * P.lp40 + pk.core * P.core);
				if (diff < 0) lines.push({ k: 'Prix pack ' + pk.name, v: diff });
			});
			var total = 0, devis = false;
			lines.forEach(function (l) { if (l.devis) devis = true; else total += l.v; });
			var s = state.sel;
			var x = 2 + (s.rear !== 'none' ? 2 : 0) + (s.center !== 'none' ? 1 : 0);
			var code = x + '.' + (s.sub !== 'none' ? 1 : 0) + (s.ceil !== 'none' ? '.2' : '');
			var mods = {}, order = [];
			lines.filter(function (l) { return l.mod; }).forEach(function (l) {
				var m = l.k.match(/^(\d+) × (.*)$/), n = m ? +m[1] : 1, name = m ? m[2] : l.k;
				if (!mods[name]) order.push(name);
				mods[name] = (mods[name] || 0) + n;
			});
			return {
				lines: lines, total: total, devis: devis, code: code,
				invalid: s.rear === 'none' && s.ceil === 'none',
				mods: order.map(function (k) { return mods[k] + ' × ' + k; })
			};
		}

		function calUrl(c) {
			var N = { r3: 'Monitor Audio Radius 3 4G', r1: 'Monitor Audio Radius 1 4G', minx: 'Cambridge Minx 22', msx: 'Cambridge MSX SUB 300', devis: 'autre modèle (sur devis)', own: 'mes enceintes', ownActive: 'mes enceintes actives', none: 'sans' };
			var parts = ZONES.map(function (z) {
				var o = state.sel[z.id], t = N[o];
				if (z.id === 'center' && o === 'minx') t += ' + support';
				if (state.stand[z.id] && (o === 'r1' || o === 'r3')) t += ' + pieds Stand Floor';
				if (zoneLines(z.id, o).some(function (l) { return /100W/.test(l.k); })) t += ' (IcePower 100W)';
				return z.label + ' : ' + t;
			});
			var txt = 'Config Harmony ' + (c.invalid ? 'incomplète' : c.code) + ' — ' + parts.join(' · ') +
				' — Modules : ' + c.mods.join(', ').replace(/ × /g, ' ') +
				' — Prix indicatif : ' + (c.devis ? 'dès ' : '') + eur(c.total) + (c.devis ? ' hors devis' : '');
			return CAL + (CAL.indexOf('?') > -1 ? '&' : '?') + 'notes=' + encodeURIComponent(txt);
		}

		var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="6" y="2.5" width="12" height="19" rx="2.5"/><circle cx="12" cy="14.5" r="3.5"/><circle cx="12" cy="7" r="1.5"/></svg>';
		var $ = function (sel) { return root.querySelector(sel); };

		function render() {
			var c = compute();
			var zi = ZONES.findIndex(function (z) { return z.id === state.zone; });
			var zone = ZONES[zi], z = zone.id, cur = state.sel[z], grp = groupOf(z, cur);

			// En-tête : code de config
			$('[data-hc-code]').textContent = c.invalid ? '—' : c.code;
			$('[data-hc-code-label]').textContent = c.invalid ? (state.touched ? 'Configuration incomplète' : 'Choisissez vos enceintes') : 'Votre configuration Harmony';

			// Plan de la pièce
			root.querySelectorAll('[data-spot]').forEach(function (el) {
				var zz = el.getAttribute('data-spot'), on = state.sel[zz] !== 'none', mine = groupOf(zz, state.sel[zz]) === 'own';
				el.classList.toggle('is-on', on && !mine);
				el.classList.toggle('is-own', on && mine);
				el.classList.toggle('is-focus', zz === z);
				el.setAttribute('aria-pressed', String(zz === z));
			});

			// Onglets
			$('[data-hc-tabs]').innerHTML = ZONES.map(function (zz) {
				return '<button type="button" class="hc-tab' + (zz.id === z ? ' is-sel' : '') + '" data-zone="' + zz.id + '" aria-pressed="' + (zz.id === z) + '">' + zz.label + '</button>';
			}).join('');

			// Panneau de l'emplacement
			var keys = ['ours', 'own', 'none'].filter(function (k) { return k !== 'none' || GROUPS[z].none; });
			var list = grp === 'none' ? [] : GROUPS[z][grp];
			var showOpts = grp === 'ours' || list.length > 1;
			var html = '<h3 class="hc-zone-title">' + zone.title + '</h3><p class="hc-zone-sub">' + zone.sub + '</p>';
			html += '<div class="hc-seg">' + keys.map(function (k, i) {
				return '<button type="button" class="hc-seg-b' + (k === grp ? ' is-sel' : '') + '" data-group="' + k + '" aria-pressed="' + (k === grp) + '">' + SEG[z][i] + '</button>';
			}).join('') + '</div>';
			if (showOpts) {
				html += '<div class="hc-opts">' + list.map(function (id) {
					var I = info(z, id), L = zoneLines(z, id), sum = 0, dv = false;
					L.forEach(function (l) { if (l.devis) dv = true; else sum += l.v; });
					var price = dv ? 'Sur devis' : (sum ? '+' + eur(sum) : 'Inclus');
					var sub = dv ? '' : (L.some(function (l) { return l.mod; }) ? 'modules inclus' : '');
					var img = I.img ? '<img src="' + esc(I.img) + '" alt="" loading="lazy" width="112" height="112">' : ICON;
					return '<button type="button" class="hc-opt' + (id === cur ? ' is-sel' : '') + '" data-opt="' + id + '" aria-pressed="' + (id === cur) + '">' +
						'<span class="hc-opt-img">' + img + '</span>' +
						'<span><span class="hc-opt-name">' + I.name + '</span>' + (I.desc ? '<span class="hc-opt-desc">' + I.desc + '</span>' : '') + '</span>' +
						'<span class="hc-opt-price">' + price + (sub ? '<small>' + sub + '</small>' : '') + '</span></button>';
				}).join('') + '</div>';
			} else if (grp === 'own') {
				html += '<p class="hc-note">' + (NOTE_OWN[z] || '') + '</p>';
			}
			var standZone = (z === 'front' && cur === 'r3') || (z === 'rear' && (cur === 'r1' || cur === 'r3'));
			if (standZone) {
				html += '<div class="hc-tgl"><div><b>Pieds Monitor Audio Stand Floor</b><span>+' + eur(P.stand) + ' la paire</span></div>' +
					'<button type="button" class="hc-sw' + (state.stand[z] ? ' is-on' : '') + '" data-toggle="stand" role="switch" aria-checked="' + !!state.stand[z] + '" aria-label="Ajouter les pieds"></button></div>';
			}
			var lpN = zoneLines(z, cur).filter(function (l) { return /Link Power/.test(l.k); }).reduce(function (a, l) { return a + l.n; }, 0);
			if (lpN > 0 && OCTAVIO_MODELS.indexOf(cur) < 0) {
				html += '<div class="hc-tgl"><div><b>Amplification IcePower 100W</b><span>Pour cet emplacement · +' + eur(lpN * (P.lp100 - P.lp40)) + '</span></div>' +
					'<button type="button" class="hc-sw' + (state.w100[z] ? ' is-on' : '') + '" data-toggle="w100" role="switch" aria-checked="' + !!state.w100[z] + '" aria-label="Passer en 100W"></button></div>';
			}
			if (c.invalid && state.touched) html += '<p class="hc-warn">Harmony a besoin d’enceintes arrière ou plafond pour créer l’effet spatial (configuration minimale 4.0 ou 2.0.2).</p>';
			var next = ZONES[zi + 1];
			if (next) html += '<button type="button" class="hc-next" data-next="' + next.id + '">Suivant : ' + next.label + ' →</button>';
			$('[data-hc-zone]').innerHTML = html;

			// Bandeau prix
			$('[data-hc-price-label]').textContent = c.devis ? 'Prix indicatif, hors éléments sur devis' : 'Prix indicatif';
			$('[data-hc-total]').textContent = (c.invalid && !state.touched && P.packStarter) ? 'dès ' + eur(P.packStarter) : (c.devis ? 'dès ' : '') + eur(c.total);
			// Tant que rien n'est choisi, la liste des modules (le Bridge seul) induirait en erreur
			$('[data-hc-mods]').textContent = (c.invalid && !state.touched) ? '' : c.mods.join(' · ');
			$('[data-hc-cta]').setAttribute('href', calUrl(c));
			var recap = $('[data-hc-recap]');
			recap.hidden = !state.recap;
			$('[data-hc-recap-btn]').textContent = state.recap ? 'Masquer le détail' : 'Voir le détail';
			$('[data-hc-recap-btn]').setAttribute('aria-expanded', String(state.recap));
			recap.querySelector('[data-hc-lines]').innerHTML = c.lines.map(function (l) {
				return '<div class="hc-rl"><span>' + l.k + '</span><span>' + (l.devis ? 'Sur devis' : (l.v < 0 ? '−' + eur(-l.v) : eur(l.v))) + '</span></div>';
			}).join('');
		}

		root.addEventListener('click', function (e) {
			var t = e.target.closest('button');
			if (!t || !root.contains(t)) return;
			var z = state.zone;
			if (t.hasAttribute('data-zone')) state.zone = t.getAttribute('data-zone');
			else if (t.hasAttribute('data-next')) {
				state.zone = t.getAttribute('data-next');
				var panel = $('.hc-panel');
				if (panel && panel.getBoundingClientRect().top < 0) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
			else if (t.hasAttribute('data-group')) {
				var g = t.getAttribute('data-group');
				if (g !== groupOf(z, state.sel[z])) state.sel[z] = g === 'none' ? 'none' : GROUPS[z][g][0];
			}
			else if (t.hasAttribute('data-opt')) state.sel[z] = t.getAttribute('data-opt');
			else if (t.getAttribute('data-toggle') === 'stand') state.stand[z] = !state.stand[z];
			else if (t.getAttribute('data-toggle') === 'w100') state.w100[z] = !state.w100[z];
			else if (t.hasAttribute('data-hc-recap-btn')) state.recap = !state.recap;
			else return;
			if (!t.hasAttribute('data-zone') && !t.hasAttribute('data-next') && !t.hasAttribute('data-hc-recap-btn')) state.touched = true;
			render();
			// Sur mobile, le panneau est sous le plan : on y descend après un clic sur le plan
			if (t.hasAttribute('data-spot') && window.innerWidth < 990) $('.hc-panel').scrollIntoView({ behavior: 'smooth', block: 'start' });
		});

		render();
	}

	function boot() {
		document.querySelectorAll('[data-harmony-configurateur]').forEach(function (el) {
			if (el.dataset.hcReady) return;
			el.dataset.hcReady = '1';
			init(el);
		});
	}
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
	else boot();
	document.addEventListener('shopify:section:load', boot);
})();
